export default __webpack_public_path__ + "static/media/img-0058-usa-full-face.ca3a46b5.png";